import React from "react";

import { Cell, Tooltip, PieChart, Pie } from "recharts";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import TaskBadges from "./TaskBadgets";

export default function Charts(props) {

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      percent,
      index,
    }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
    
      return (
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      );
    };

    const COLORS = {
        YES: "#0088FE",
        "W/R": "#dbdbdb",
        NO: "#ff6161",
      };

    const _rows = props.rows.sort((a, b) => a.no - b.no);
    const tasks = props.tasks;
    const products = props.products;
    const hashTasks = tasks.reduce(
      (hash, task) => ({ ...hash, [task.name]: task.input_type }),
      {}
    );
    const hash = {};
    for (const child of props.childs ?? []) {
      for (const task of tasks) {
        const main = hash[task.name] ?? {};
        for (const product of products) {
          const [row] = [..._rows]
            .filter((row) => row.task === task.name)
            .filter((row) => row.product === product.name)
            .filter((row) => row.round === child.wave)
            .filter((row) => row.pos === child.name);
          if (!row) {
            continue;
          }
          main[row.product] = main[row.product] ?? {};
          hash[task.name] = main;
          const summary = hash[task.name][row.product];
          summary.rates = summary.rates
            ? [...summary.rates, row.rate]
            : [row.rate];
  
          summary.quantity = summary.quantity
            ? row.quantity + summary.quantity
            : row.quantity;
          summary.rates = summary.rates
            ? [...summary.rates, row.rate]
            : [row.rate];
          summary.qualifyes = summary.qualifyes
            ? [...summary.qualifyes, row.yesno]
            : [row.yesno];
  
          hash[task.name][row.product] = summary;
        }
      }
    }
  
    const raw = Object.entries(hash).sort((a, b) => {
      const _a = Number(a[0].slice(4, 5));
      const _b = Number(b[0].slice(4, 5));
      return _a - _b;
    });
  
    return (
      <>
        <Card.Body className="p-4 mt-5">
          <Container>
            {raw.map(([task, products], key) => {
              return (
                <Col key={key}>
                  <Row>
                    <h4>
                      {task} {TaskBadges(hashTasks[task])}
                    </h4>
                  </Row>
                  {Object.entries(products).map(([product, data], key) => {
                    const qualifyes = data.qualifyes.filter(Boolean).reduce(
                      (hash, val) => ({
                        ...hash,
                        [val]: hash[val] ? hash[val] + 1 : 1,
                      }),
                      {}
                    );
                    const qualifyes_rows = Object.entries(
                      qualifyes
                    ).map(([name, value]) => ({ name, value: Number(value) }));
                    const rate =
                      data.rates.reduce((t, c) => t + c, 0) / data.rates.length;
                    return (
                      <div key={key}>
                        <Row className="w-100">
                          {"  "}
                          <h5 className="text-muted">{product}</h5>
                        </Row>
                        <Row>
                          <Col>
                            <PieChart width={200} height={200}>
                              <Pie
                                data={
                                  hashTasks[task].includes("Yes/No")
                                    ? qualifyes_rows
                                    : [{ name: "W/R", value: 1 }]
                                }
                                cx={100}
                                cy={100}
                                label={renderCustomizedLabel}
                                isAnimationActive={true}
                                labelLine={false}
                                outerRadius={70}
                                fill="#dbdbdb"
                                dataKey="value"
                              >
                                {qualifyes_rows.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[entry.name]}
                                  />
                                ))}
                                <Tooltip />
                              </Pie>
                            </PieChart>
                          </Col>
                          <Col
                            className="p-5 my-auto text-center"
                            style={{ height: "100%" }}
                          >
                            {hashTasks[task].includes("Quantity") ? (
                              <Container>
                                <h1>
                                  {data.quantity}
                                  <small className="text-muted">/units</small>
                                </h1>
                              </Container>
                            ) : (
                              <Container className="text-muted">
                                <h1>
                                  0<small className="text-muted">/units</small>
                                </h1>
                              </Container>
                            )}
                          </Col>
                          <Col
                            className="p-5 my-auto text-center"
                            style={{ height: "100%" }}
                          >
                            {hashTasks[task].includes("Rate") ? (
                              <Container>
                                <h1>
                                  {rate}
                                  <small className="text-muted">/5</small>
                                </h1>
                              </Container>
                            ) : (
                              <Container className="text-muted">
                                <h1>
                                  0<small className="text-muted">/0</small>
                                </h1>
                              </Container>
                            )}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>
              );
            })}
          </Container>
        </Card.Body>
        <Card.Footer className="d-flex flex-row-reverse"></Card.Footer>
      </>
    );
  }